import { api } from '../api';
import type { TenantListKind, TenantLists } from '@/types/tenant-list';

/**
 * The tenant's configuration lists (T-1006).
 *
 * One list is replaced wholesale rather than added to: the order is the
 * tenant's — a kitchen puts what it reaches for first at the top — and an
 * add/remove API cannot express a reorder without inventing a second one.
 */
export const tenantListApi = {
  get: () => api.get<TenantLists>('/tenant-lists'),

  update: (kind: TenantListKind, values: string[]) =>
    api.put<TenantLists>(`/tenant-lists/${kind}`, { values }),
};
